import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import i18next from 'i18next';
import styles from './TradePanel.less';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ButtonToolbar, DropdownButton, MenuItem, Button } from 'react-bootstrap';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import { applyStyle, applyToHover, getDefaultAcdAccount, getSeparator, setDirection,unformatLang} from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { displayInActiveAccMsg } from '../../utils/validation';

let separator;
let decimal;
let decimalCount = 0;
let wsData;

// let index1 = 0;
// let cmdtyId;
// let COM;

// const elementsData = [
//   {"classNames":"header","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"trdDropDown","elementType":"tag", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"trdComments","elementType":"normal", "applyTo":"all", "tagNames":"textarea"},
//   {"classNames":"lmtModal","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dropDownList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"onTop","elementType":"normal", "applyTo":"all", "tagNames":"label"}
// ];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIconLmt","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col4","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"submitBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];

@connect(
  state => ({
    ACD: state.auth.ACD,
    userDetail:state.auth.userDetail,
    fixKeyValue : state.dashboardRoot.dashboardReducer.fixKeyValue,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    validFixingOrders:state.dashboardRoot.dashboardReducer.validFixingOrders,
    trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
    socketData: state.dashboardRoot.instrumentListReducer.socketData,
    socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
    check:state.dashboardRoot.instrumentListReducer.check,
    status: state.dashboardRoot.instrumentListReducer.status,
    //ordcnfrmsg:state.dashboardRoot.activityReducer.ordcnfrmsg,
    //cmdtyArr:state.dashboardRoot.instrumentListReducer.cmdtyArr,
    //closeLmtFlag:state.dashboardRoot.dashboardReducer.closeLmtFlag,
    TCO:state.dashboardRoot.instrumentListReducer.TCO,
    lmtKeyValue : state.dashboardRoot.dashboardReducer.lmtKeyValue,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    stkWiseMarkup:state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    stkWiseMarkupRandomNo:state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
    orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
    //checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  }),
  {	...authActions,
    ...dashboardActions,
    ...tradepanelActions,
    ...commonActions,
    ...instrumentListActions,
    ...activityActions})

@track((props, state) => ({}))

export default class FixOrder extends Component {
  static propTypes = {
    //pushState: PropTypes.func,
    closedFixModal:PropTypes.func,
    fixKeyValue:PropTypes.string,
    getValidFixingEvents:PropTypes.func,
    socketData: PropTypes.array,
    socketDataStatic:PropTypes.array,
    check:PropTypes.string,
    trdPanelData: PropTypes.object,
    handleSellBuyFIXOrder:PropTypes.func,
    //ordcnfrmsg:PropTypes.object,
    //closedLmtModal:PropTypes.func,
    //closeLmtFlag:PropTypes.bool,
    TCO: PropTypes.object,
    lmtKeyValue:PropTypes.string,
    stkWiseMarkup:PropTypes.object,
    stkWiseMarkupRandomNo:PropTypes.Number,
    validateOrder:PropTypes.func,
  }

  constructor(props){
    super(props);
    this.changeFixingDate = this.changeFixingDate.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  state = {
    cmdtyList:[],
    selectedFixing:'',
    selectedFixingCode:'',
    selectedFixingTime:'',
    selectedCmdtyId:'',
    selectedCmdty:'',
    valDate:new Date(),
    dealTypevalue:'BUY',
    dealType:1,
    quantity:"",
    DFFIX:[],
    stkList:[],
    selectedStkCode:'',
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    fixingDate: moment(new Date()),
    futureValDate: moment(),
    remarks:'',
    convFactor:null,
    COM:null,
    selectedQuantityFix: "",
    selectedMeasureFix: "",
    MEASURE:[],
    Price: "",
    DealType: '',
    Validty: '',
    ValidtyKey: 0,
    showFixDialog: false,
    CTID: '',
    errorMsg:"",
    //isSubmitDisabled:false,
    cmdtyIndex:0,
    showtrdFlagModal:false,
    //showCnfrmMsg:false,
    TCO:[],
		OrderType:2,
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    showPrice:'',
    orderSocketClosed:false,
    isFieldDisabled:true,
    defaultAccountIsActive: false
  }

  componentWillMount() {

  }

  componentDidMount() {
    var fd = moment(new Date()).format("YYYY/MM/DD")
    this.props.getValidFixingEvents(fd);
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"}
    ];
    //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo){
      this.getStkWiseMarkup(this.state.selectedMeasureFix,this.state.selectedCmdtyId,nextProps.stkWiseMarkup);
    }
    if(nextProps.userDetail.showPrice!==this.state.showPrice){
      if(nextProps.userDetail.showPrice!==undefined&&nextProps.userDetail.showPrice!=="undefined"){
        const showPrice = nextProps.userDetail.showPrice===undefined||nextProps.userDetail.showPrice==="undefined"?"BOTH":nextProps.userDetail.showPrice;
        var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
        var dealTypeKey = showPrice === "ASK" || showPrice === "BOTH"?1:0;
        this.setState({showPrice:showPrice,dealTypevalue: i18next.t(DealType),dealType:dealTypeKey});
      }
    }

  }

  clearOrder= (event) => {
    try{
      this.props.closedFixModal(false, this.props.fixKeyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'clearOrder', component:"FixOrder"});
    }
  }

  onSelectDealType=(name,val)=>{
    try{
      this.setState({dealTypevalue:name});
      this.setState({dealType:val});
      this.checkInputData(val,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,this.state.remarks,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onSelectDealType', component:"FixOrder"});
    }
  }

  cmdtySelection=(cmdtyId,cmdtyDes)=>{
    try{
      this.setState({
        selectedCmdtyId:cmdtyId,
        selectedCmdty:cmdtyDes
      });
      this.checkInputData(this.state.dealType,this.state.fixingDate,cmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,this.state.remarks,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'cmdtySelection', component:"FixOrder"});
    }
  }

  fixingSelection = (fixingDet) =>{
    try{
      this.setState({
        cmdtyList:fixingDet.IID,
        selectedCmdtyId:fixingDet.IID[0].ID,
        selectedCmdty:fixingDet.IID[0].DESC,
        selectedFixing:fixingDet.FN,
        selectedFixingCode:fixingDet.FC,
        selectedFixingTime:fixingDet.FT,
        isFieldDisabled:false
      });
      const T1 = fixingDet.FPS;
      this.setState({T1:T1});
      let index1;
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        const cmdty = this.props.socketDataStatic[index].I;
        const cmdtyDes = this.props.socketDataStatic[index].ID;
        if (fixingDet.IID[0].ID === cmdty) {
          index1=index;
          break;
        }
      }
      this.setState({COM:parseInt(this.props.socketDataStatic[index1].B)});
      const unit = [];
      var tmpConvFactor=new Map();
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        if (stk_type === T1) {
          unit.push(this.props.trdPanelData[index].C);
          tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
        }
      }
      this.getStkWiseMarkup(unit[0],fixingDet.IID[0].ID,this.props.stkWiseMarkup);
      this.setState({convFactor:tmpConvFactor});
      this.setState({MEASURE:unit});
      this.setState({selectedMeasureFix:unit[0]});

      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (T1===stk_type && type===unit[0]) {
            const DF = this.props.trdPanelData[index].DF;
            const conv_Factor = this.props.trdPanelData[index].F;
            const DFParse=JSON.parse(DF);
            this.setState({DFFIX:DFParse});
            this.setState({convFact:conv_Factor});
        }else if((this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===1)||
          (this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===2)){
          const DF=this.props.socketDataStatic[index1].DF;
          const DFParse=JSON.parse(DF);
          this.setState({DFFIX: DFParse});
        }
      }
      this.checkInputData(this.state.dealType,this.state.fixingDate,fixingDet.IID[0].ID,fixingDet.FC,fixingDet.FN,fixingDet.FT,this.state.selectedQuantityFix,this.state.remarks,this.state.selectedMeasureFix)
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixingSelection', component:"FixOrder"});
    }
  }

  changeFixingDate = (date) => {
    try{
      this.setState({fixingDate: date});
      var fd = moment(date,"DD-MM-YYYY").format('YYYY/MM/DD');
      this.props.getValidFixingEvents(fd);
      this.checkInputData(this.state.dealType,fd,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,this.state.remarks,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFixingDate', component:"FixOrder"});
    }
  }

  onBlurRmk=(e)=>{
    try{
      this.setState({remarks:e.target.value});
      this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,e.target.value,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurRmk', component:"FixOrder"});
    }
  }

  getStkWiseMarkup = (stk_code,cmdty,stkWiseMarkup) =>{
    try{
      if(stk_code!==undefined){
        if(stkWiseMarkup!==null){
          let stkCodeMarkup=stkWiseMarkup.get(cmdty);
          for(let i=0;i<stkCodeMarkup.length;i++){
            if(stkCodeMarkup[i].SC===stk_code){
              this.setState({stkWiseAskMarkup: stkCodeMarkup[i].ASK,stkWiseBidMarkup: stkCodeMarkup[i].BID});
            }
          }
        }
      }else{
        this.setState({stkWiseAskMarkup: 0,stkWiseBidMarkup: 0});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"FixOrder"});
    }
  }

  quantitySelectionFix = (event) => {
    try{
        if(event.target.text==="")
        {
          event.target.text="0"
        }
        var check= event.target.text.slice(event.target.text.length-1);
        var tempQ= event.target.text;
        if(check.toUpperCase()==='K')
        {
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
        }else if(check.toUpperCase()==='M'){
          tempQ= event.target.text.slice(check, -1);
          tempQ=parseFloat(tempQ)*1000000;
        }
        this.setState({selectedQuantityFix: tempQ});
        this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionFix', component:"FixOrder"});
    }
  }

  quantityTypedFix = (event) => {
    try{
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
        event.target.value="0"+event.target.value;
      }
      var flag=0;
      var c=0;
      for(var i=0;i<event.target.value.length;i++){
        if(event.target.value.charAt(i)=== checkDecimal){
          flag=1;
        }
        if(flag==1){
          c++;
        }
      }
      if(c>4){
        event.target.value= this.state.selectedQuantityFix;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
      var check= event.target.value.slice(event.target.value.length-1);
      var tempQ= event.target.value;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
        if(!isNaN(tempQ)){
        this.setState({selectedQuantityFix: tempQ});
      }else{
        this.setState({selectedQuantityFix: event.target.value});
      }
      }
      else{
        this.setState({selectedQuantityFix: event.target.value});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantityTypedFix', component:"FixOrder"});
    }
  }

  selectMeasureFix = (event) => {
    try{
      this.setState({selectedMeasureFix: event.target.text});
      for (let index = 0; index < this.props.trdPanelData.length; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1===stk_type && type===event.target.text) {
          const DF = this.props.trdPanelData[index].DF;
          const DFParse=JSON.parse(DF);
          this.setState({DFFIX:DFParse});
        }
      }
      this.getStkWiseMarkup(event.target.text,this.state.selectedCmdtyId,this.props.stkWiseMarkup);
      this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,this.state.remarks,event.target.text);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureFix', component:"FixOrder"});
    }
  }

  onBlurFIX= (event)=> {
    try{
      var tempQ=event.target.value;
      if(tempQ===""){
      tempQ = "";
      }
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
      event.target.value="0"+event.target.value;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
        var check= event.target.value.slice(event.target.value.length-1);
        tempQ= event.target.value;
        tempQ = unformatLang(tempQ);
        if(check.toUpperCase()==='K')
        {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
        }
        else if(check.toUpperCase()==='M')
        {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
        }
        if(!isNaN(tempQ) && tempQ !=="" && tempQ !== 0)
        {

        tempQ= event.target.value;
        tempQ = unformatLang(tempQ);
        if(tempQ==="" || tempQ==="NaN" ){
          tempQ ="";
        }
        var tempQuant=Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
        this.setState({selectedQuantityFix: tempQuant});
        tempQuant=unformatLang(tempQuant)
        this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQuant,this.state.remarks,this.state.selectedMeasureFix);
        tempQ=parseFloat(tempQ).toFixed(2);
      }
      else{
        if(event.target.value===""){
          tempQ = "";
        }
        this.setState({selectedQuantityFix: tempQ});
        this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
      }
      }
      else{
        if(tempQ===""){
          tempQ = "";
        }
        if(!isNaN(tempQ)){
          tempQ=Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
          this.setState({selectedQuantityFix:tempQ});
          this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
        } else{
          this.setState({selectedQuantityFix:tempQ});
          this.checkInputData(this.state.dealType,this.state.fixingDate,this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurFIX', component:"FixOrder"});
    }
  }

  checkNumberValue =(event) =>{
    try{
      if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal) && (event.which !== 107)  && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)){
         event.preventDefault();
       }
      if(event.target.value.indexOf(decimal)===-1){
            decimalCount = 0;
      }
      // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
      //     event.preventDefault();
      // }
      if(event.which === decimal.charCodeAt(0)){
        decimalCount+=1;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"FixOrder"});
    }
  }

  closeTrdFlagModal = (event) => {
    try{
      this.setState({showtrdFlagModal:false, defaultAccountIsActive: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeTrdFlagModal', component:"FixOrder"});
    }
  }

  closeFixModal = (event) => {
    try{
      this.setState({showFixDialog:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeFixModal', component:"FixOrder"});
    }
  }

  fixOrderValidate = () =>{
    try{
      var newdate = moment().add(1,'months');
      var momentA = moment(this.state.fixingDate,"DD-MM-YYYY");
      var selectedMeasure=this.state.selectedMeasureFix;
      var selectedQuantity =unformatLang(this.state.selectedQuantityFix);
      let flag = 0;
      selectedQuantity=selectedQuantity+"";
      var tempQ= selectedQuantity;
      var check= selectedQuantity.slice(selectedQuantity-1);
      const defaultAcc = getDefaultAcdAccount(this.props.ACD)
      this.setState({
        defaultAccountIsActive: Boolean(Number(defaultAcc.isActiveAcc))
      })
      if(this.props.orderStatus === 2 || this.props.orderStatus === 3){
        this.setState({errorMsg:"orderCannotBeplacedfortheMoment"});
        flag=1;
      }
      if(check.toUpperCase()==='K')
      {
        tempQ= selectedQuantity.slice(check, -1);
        tempQ=parseInt(tempQ)*1000;
      }
      if(this.state.COM===1){
        selectedMeasure="";
      }
      var error = '';
      this.setState({errorMsg:""});
      if(parseInt(this.props.status) !== 0){
        flag=1;
        this.setState({errorMsg:"noRatesMsg"});
      }
      if(parseFloat(tempQ) === 0){
        flag=1;
        this.setState({errorMsg:"qtyNotZeroMsg"});
      }
      if((parseFloat(tempQ) === "")&&(parseFloat(tempQ) === '')){
        flag=1;
        this.setState({errorMsg:"minEnterQty"});
      }
      if(this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0){
        flag=1;
        this.setState({errorMsg:"fractionDigitErrMsg"});
      }
      if (selectedMeasure === '') {
        flag = 1;
        this.setState({errorMsg:'selectQtyTypeMsg'});
      }
      if (selectedMeasure === '' && flag!==1) {
      flag = 1;
      this.setState({errorMsg:"Please select quantity type"});
      }
      if(this.state.selectedFixing ===''&&this.state.selectedFixing===""){
      flag=1;
      this.setState({errorMsg:"Please select Fixing Event"});
      }
      if(momentA.isAfter(newdate)){ //// value date should be within one year check
        flag =1;
        this.setState({errorMsg:"Please Enter Fixing Date within One Month From Current Date"});
      }
      var sockCmdty=this.props.socketData.get(this.state.selectedCmdtyId);
      var askRate=parseFloat(sockCmdty.ask)-this.state.stkWiseAskMarkup;
      var bidRate=parseFloat(sockCmdty.bid)-this.state.stkWiseBidMarkup;
      let baseInstId = sockCmdty.BI;
      var rate = this.state.dealType ===1 ? askRate : bidRate;
      var ValueDate=sockCmdty.VD;
      if (tempQ === '') {
        flag=1;
        this.setState({errorMsg:"minEnterQty"});
      }

      if (flag === 1) {
        this.setState({showFixDialog:true});
      } else {
        if (Number(defaultAcc.isActiveAcc) && this.props.userDetail.canTrade) {
          const user = JSON.parse(localStorage.getItem('user'));
          var CTID =user.location+"_"+user.SID+Math.floor((Math.random() * 1000000) + 1);
          this.props.setOrdersCTID(CTID);
          this.handleFixOrder(this.state.selectedCmdtyId, selectedQuantity, rate, this.state.dealType, CTID, selectedMeasure, this.state.remarks, ValueDate, this.state.selectedFixingCode, this.state.selectedFixing, this.state.selectedFixingTime, baseInstId);

          const showPrice = this.props.userDetail.showPrice === undefined || this.props.userDetail.showPrice === "undefined" ? "BOTH" : this.props.userDetail.showPrice;
          var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
          this.setState({dealTypevalue:i18next.t(DealType), showPrice:this.props.userDetail.showPrice});
          if(this.props.userDetail.storetradeqty === "0") {
            this.setState({selectedQuantityFix :""});
          }
          this.setState({remarks:""});
          this.props.closedFixModal(false, this.props.fixKeyValue);
        }else {
          this.setState({showtrdFlagModal:true});
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixOrderValidate', component:"FixOrder"});
    }
  }

  @track((props, state) => ({ 
      widgetDetails: { tab: "FIX", originFunction: "handleFixOrder", event: appConstants.trackingEvents.PLACE_ORDER},
      ordDetails: [wsData]
    }))

  handleFixOrder = (CmdtyPair, selectedQuantity, Price, dealType, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, baseInstId) => {
    try{
      selectedQuantity=selectedQuantity+"";
      var tempQ= selectedQuantity;
      var check= selectedQuantity.slice(selectedQuantity-1);
      if (check.toUpperCase() === 'K') {
        tempQ= selectedQuantity.slice(check, -1);
        tempQ=parseInt(tempQ)*1000;
      }
      let fixingDate = moment(this.state.fixingDate,"DD-MM-YYYY").format('YYYY/MM/DD');
      let processedData={
                  "IID":CmdtyPair,
                  "PQ":tempQ,
                  "DT":dealType,
                  "R":Price,
                  "FD":fixingDate,
                  "CTID":CTID,
                  "SC":selectedMeasure,
                  "RMK":remark,
                  "VD":ValueDate,
                  "FC":selectedFixingCode,
                  "FN":selectedFixing,
                  "FT":selectedFixingTime,
                  "BSIID":baseInstId
      };
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet=JSON.parse(localStorage.getItem('DFA'));
      const platform = localStorage.getItem('platform');
      let priceValue = Price;
      let quant = tempQ;

      if (!priceValue) {
        priceValue = 0;
      }
      if (quant === '') {
        quant = 0;
      }
      wsData={
            "MT": "NEW_ORDER",
            "UID":user.UID,
            "UD": user.UD,
            "UCD":user.trdCode,
            "IID": CmdtyPair,
            "PQ": parseFloat(quant),
            "DT": dealType,
            "R": parseFloat(priceValue),
            "OT": 4,
            "CID": user.location,
            "AC": AccDet.C,
            "AD": AccDet.D,
            "SC": selectedMeasure,
            "OMT": 1,
            "PCT": 19,
            "RMK": remark,
            "VD": ValueDate,
            "SID":user.SID,
            "FC": selectedFixingCode,
            "FN": selectedFixing,
            "FT": selectedFixingTime,
            "CTID": CTID,
            "MD": -1,
            "FD": fixingDate,
            "BSIID": baseInstId,
      }
      let apiValidateData=[{"inputData":this.state.inputData},{"processedData":processedData},{"wsData":wsData}]
      this.props.validateOrder(JSON.stringify(apiValidateData))

      this.props.handleSellBuyFIXOrder(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, baseInstId);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleFixOrder', component:"FixOrder"});
    }
  }

checkInputData=(DT,FD,cmdtyId,FC,FN,FT,qty,rmk,selectedMeasureFix)=>{
  try{
    let inputData={
      "IID":cmdtyId,
      "DT":DT,
      "FC":FC,
      "FN":FN,
      "FT":FT,
      "FD":FD,
      "PQ":qty,
      "RMK":rmk,
      "SC":selectedMeasureFix
    };
    this.setState({inputData:inputData});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'checkInputData', component:"FixOrder"});
  }
}
  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"msg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"single", "tagNames":"div"}
      // ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"errorPara", "elementType":"normal", "applyTo":"all", "tagNames":"p"},
        {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"}
      ];
      // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"FixOrder"});
    }
  }

  render() {
    const closeIcon = <MUIIconWithTooltip icon={'Close'} className={'closeBtn'} title={i18next.t("close")}/>;
    const { selectedMeasureFix, selectedQuantityFix, Price, DealType, Validty, DFFIX, MEASURE, OrderType, showPrice, COM } = this.state;
    const defaultAcc = getDefaultAcdAccount(this.props.ACD)
    const tradeDayEnd = moment(this.props.userDetail.dayEndTime).utc().format('YYYY-MM-DD')

    const isWeekday = date => {
      const day = new Date(date).getDay();
      return day !== 0 && day !== 6;
    };

    return (
      <React.Fragment>
        <Modal isOpen={this.state.showtrdFlagModal} className={styles.warningModal} id="trdingErrorModal"  onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>{i18next.t('error')}</span>
              <span onClick={this.closeTrdFlagModal} className={`${styles.closeicon} closeIcon closeIconLmt commonCloseIcon`} id="lmtCloseTrdModal">{closeIcon}</span>
            </div>
            <div className={`${styles.msg} msg commonMsgDir`}>
              <p className={`errorPara`}>{i18next.t(!this.state.defaultAccountIsActive ? displayInActiveAccMsg(defaultAcc.D,defaultAcc.C) : 'tradingDisbleByDealerMsg')}</p>
            </div>
          </div>
        </Modal>

        <Modal isOpen={this.state.showFixDialog} className={styles.warningModal} id="errorMsgModal" onAfterOpen={this.afterOpenModal}>
          <div ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('error')}</span>
              <span onClick={this.closeFixModal} id="lmtCloseOrdModal" className={`${styles.closeImg} closeIcon closeIconLmt commonCloseIcon`}>{closeIcon}</span>
            </div>
            <div className={`${styles.msg} msg commonMsgDir`} id="errorMsg">
              {this.state.errorMsg && this.state.errorMsg != "" ? <p className={`errorPara`}>{i18next.t(this.state.errorMsg)}</p> : null}
            </div>
          </div>
        </Modal>

        <div id="fixOrdr">
          <div className={`${styles.header} header`}>
            <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('Place Fixing Order')}</span>
            <span id="fixCloseModalIcon" className={`${styles.closeImg} closeIcon closeIconFix`} onClick={this.clearOrder}>{closeIcon}</span>
          </div>

          <div className={styles.trdwrapper}>
            <div className={styles.lmtWidgetwrapper}>
              <div className="row mt-4">
                <div className="col-xs-3 form-group hangLbl">
                  <label className="onTop">Fixing Date</label>
                  <div id="fixingDatePicker">
                    <div className="datepickerInputBox">
                      <DatePicker readOnly filterDate={isWeekday} selected={this.state.fixingDate} dateFormat="DD-MM-YYYY" onChange={this.changeFixingDate} ref="datepickerRef" id="lmtOrdDatePicker" className="datePickerIcon trdDropdownInput form-control"
                      minDate={tradeDayEnd} />
                    </div>
                  </div>
                </div>

                <div className="col-xs-9 form-group">
                  <ButtonToolbar>
                    <DropdownButton id="fixingEvent" className="form-control trdDropDown btnText" title={this.state.selectedFixing !== '' ? this.state.selectedFixing : "Select Fixing Event"} >
                      {this.props.validFixingOrders.map((item, index) => {
                        return (
                          <MenuItem eventKey={item.FC} onClick={()=>this.fixingSelection(item)}>{item.FN}</MenuItem>
                        );
                      })}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-auto form-group">
                  <ButtonToolbar>
                    <DropdownButton id="fixCmdtyList" className={`${styles.cmdtyPairtrdDropDown} form-control trdDropDown btnText`} title={this.state.selectedCmdty} disabled={this.state.isFieldDisabled}>
                      {this.state.cmdtyList.map((item, index) => {
                        return (
                          <MenuItem eventKey={item.ID} onClick={()=>this.cmdtySelection(item.ID, item.DESC)}>{item.DESC}</MenuItem>
                        );
                      })}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>

                <div className="col-auto form-group">
                  <ButtonToolbar>
                    <DropdownButton id="fixDealType" className="form-control trdDropDown btnText" title={i18next.t(this.state.dealTypevalue)} disabled={this.state.isFieldDisabled}>
                    {showPrice === "BOTH" || showPrice === "ASK" ? <MenuItem onClick={() =>this.onSelectDealType("BUY", 1)}>{i18next.t("BUY")}</MenuItem>:null}
                    {showPrice === "BOTH" || showPrice === "BID" ? <MenuItem onClick={() =>this.onSelectDealType("SELL", 0)}>{i18next.t("SELL")}</MenuItem>:null}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>

                <div className="col form-group">
                  <ButtonToolbar>
                    <DropdownButton id="fixQuantity" className="form-control trdDropDown btnText fixQtyDropdown" title="10" disabled={this.state.isFieldDisabled}>
                    {DFFIX.map((qntity) => {
                      return (
                        <MenuItem onClick={this.quantitySelectionFix} id="lmtOrdQauntityMenu" className="dropDownList" >{qntity}</MenuItem>
                      );
                    })}
                    </DropdownButton>
                  </ButtonToolbar>
                  <input type="text" id="lmtDropQuantity" className={`${styles.lmtDropdownInput} trdDropdownInput qtyInput`} onBlur={this.onBlurFIX} value={selectedQuantityFix} onChange={this.quantityTypedFix} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")} autoComplete="off"  disabled={this.state.isFieldDisabled}/>
                </div>

                {COM !== 1 ?
                  <div className="col-auto qtyUnits">
                    <ButtonToolbar>
                      <DropdownButton id="fixStkType" className="form-control trdDropDown btnText" title={selectedMeasureFix} disabled={this.state.isFieldDisabled}>
                        {MEASURE && MEASURE.map((unitMeasure) => {
                          return (
                            <MenuItem onClick={this.selectMeasureFix} id="lmtOrdSelectMeasure" className="dropDownList" >{unitMeasure}</MenuItem>
                          );
                        })}
                      </DropdownButton>
                    </ButtonToolbar>
                  </div>
                :null}
              </div>

              <div className="row mt-1">
                <div className="col-xs-12 form-group">
                  <input type="text" id="fixComments" className="form-control trdComments" value={this.state.remarks} onChange={this.onBlurRmk} placeholder="Comments" autoComplete="off" disabled={this.state.isFieldDisabled}/>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-xs-12">
                  {this.state.selectedFixing === '' ?
                    <p className="error">Please select a Fixing Event.</p>
                  :
                    <p><b className="text">{this.state.selectedFixing + " orders must be placed by " + this.state.selectedFixingTime +" UTC" }</b></p>
                  }
                </div>
              </div>

              <div className="row justify-content-end">
                <div className={`col-auto submitBtn ${styles.submitBtn}`}>
                  <ButtonToolbar>
                    <Button id="fixProceedbtn" className={`lmtSubmit ${styles.savebutton}`} onClick={() => this.fixOrderValidate()}>{i18next.t("proceed")}</Button>
                  </ButtonToolbar>

                  <ButtonToolbar>
                    <Button id="fixCancelbtn" className={`lmtClose ${styles.clearbutton}`} onClick={this.clearOrder}>{i18next.t("cancel")}</Button>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
